import { Badge } from '@/components/ui/badge';

export function VideoTemplateVersionBadge({ isV2 }: { isV2?: boolean }) {
  if (!isV2) return null;
  return (
    <Badge
      variant="outline"
      aria-label="V2 template"
      className="border-primary/20 bg-primary/5 px-1.5 py-0 text-[10px] leading-4 text-primary"
    >
      V2
    </Badge>
  );
}
